import { Stack, Text, ThemeIcon } from '@mantine/core';
import { IconDatabaseOff } from '@tabler/icons-react';

interface NoDataResultsProps {
	dataType: string;
}
export const NoDataResults = ({ dataType: filterType }: NoDataResultsProps) => {
	return (
		<Stack align="center" justify="center" mt="xl" px="sm">
			<ThemeIcon size={60} radius={60} color="" variant="light">
				<IconDatabaseOff size={32} />
			</ThemeIcon>
			<Text fw="bold">No results to display</Text>
			<Text style={{ textAlign: 'center' }}>There are no {filterType} to display.</Text>
		</Stack>
	);
};
